import { supabase } from '../lib/supabase';

/**
 * Real-time service for workflow nodes
 * Enables live synchronization between Node Library Management and workflow designer
 */
export const nodeLibraryRealtimeService = {
  /**
   * Subscribe to workflow nodes changes (INSERT, UPDATE, DELETE)
   * @param {Function} callback - Function to call when nodes change
   * @returns {Object} Supabase channel for unsubscribing
   */
  subscribeToNodeChanges(callback) {
    const channel = supabase?.channel('workflow_nodes_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'workflow_nodes' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Subscribe to node categories changes
   * @param {Function} callback - Function to call when categories change
   * @returns {Object} Supabase channel for unsubscribing
   */
  subscribeToNodeCategoryChanges(callback) {
    const channel = supabase?.channel('node_categories_changes')?.on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'node_categories' },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return channel;
  },

  /**
   * Unsubscribe from a channel
   * @param {Object} channel - Channel to unsubscribe from
   */
  unsubscribe(channel) {
    if (channel) {
      supabase?.removeChannel(channel);
    }
  },

  /**
   * Unsubscribe from multiple channels
   * @param {Array} channels - Array of channels to unsubscribe from
   */
  unsubscribeAll(channels) {
    channels?.forEach(channel => {
      if (channel) {
        supabase?.removeChannel(channel);
      }
    });
  }
};

export default nodeLibraryRealtimeService;
